export class Location {

  public static instance = new Location();

  public href(): string {
    return window.location.href;
  }

  public setUrl(url: string) {
    window.location.href = url;
  }

  /**
   * WARNING: This is very probably not what you are looking for!!
   * The URL structure for this project will _generally_ be something like this:
   * [scheme]://[hostname]/#/site/[sitename]/[somepath]?param1=yes&param2=test
   * 
   * Which means search() returns '' and hash() returns '#/site/[sitename]/[somepath]?param1=yes&param2=test'
   * 
   * Check out WindowLocationService on methods like getHashQueryObject() instead.
   */
  public search(): string {
    return window.location.search;
  }

  public replace(url: string) {
    window.location.replace(url);
  }

  public reload() {
    window.location.reload();
  }

  /**
   * Returns string in the form '#/somehash'
   */
  public hash(): string {
    return window.location.hash;
  }

  public setHash(newHash: string): void {
    window.location.hash = newHash;
  }
}
